import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/pro-regular-svg-icons/faBell';
import { Button } from '../Button/Button';
import { UnreadCountBubble } from '../UnreadCountBubble';

export interface Props {
  unreadNotificationsCount: number;
  handleBellClick(): void;
  handleBellBlur(): void;
}

export const Notifications = ({ unreadNotificationsCount, handleBellClick, handleBellBlur }: Props): JSX.Element => (
  <Button
    aria-label='Notifications Button'
    className='relative align-middle ml-1 lg:ml-2 mr-1 lg:mr-2 hover:opacity-80 hover:text-neutral-600 rounded-full bg-gray-300 w-9 h-9'
    onClick={handleBellClick}
    onBlur={handleBellBlur}
  >
    <FontAwesomeIcon icon={faBell} className='h-4 mt-1' />
    {!!unreadNotificationsCount && (
      <UnreadCountBubble
        unreadCount={unreadNotificationsCount}
      />
    )}
  </Button>
);
